import { useRouter } from "next/router";
import { useEffect } from "react";
import { ADMIN_PAGE_TITLE_ITEM, PAGE_TITLE_ITEM } from "src/hooks/usePageTitle";
import { useRecordUserEventMutation } from "src/service/UserEventsApi/UserEventsApi";

export const useRecordPageView = () => {
  const { asPath } = useRouter();
  const [recordEvent] = useRecordUserEventMutation();

  const records = async () => {
    const pages: { label: string; path: string; root?: string }[] = [
      ...ADMIN_PAGE_TITLE_ITEM,
      ...PAGE_TITLE_ITEM,
    ];

    const pathArray = asPath.split("/") || [];

    const headPageItem = pages.find((item) => {
      return asPath.includes("/admin")
        ? item.path === pathArray[pathArray.length - 1] && item.root === "admin"
        : item.path === pathArray[1];
    });

    const pageTitle =
      headPageItem?.path === "other"
        ? "ユーザープロフィール"
        : headPageItem?.label;
    const label =
      pageTitle ||
      (pathArray.length ? pathArray[pathArray.length - 1] : asPath);

    await recordEvent({
      action: "VIEW",
      eventType: "PAGE_VIEW",
      category: "ページビュー ",
      label: label,
      value: window.location.href,
    }).unwrap();
  };
  useEffect(() => {
    const t = setTimeout(() => {
      records();
    }, 300);

    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asPath]);
};
